module.exports = __webpack_public_path__ + "static/colors-identity-dont-4fa046c3500227a15817701b2548107a.png";